import CommentsDrawer from './comments-drawer.component';
import * as CommentsDrawerActions from './comments-drawer.actions';
import { connect } from 'react-redux';

const mapStateToProps = (state, ownProps) => {

    const props = Object.assign({}, ownProps, state.CommentsDrawer);

    return props;
};

const mapDispatchToProps = dispatch => {
    return {
    	onClose: (offsetHeight) => {
    		dispatch(CommentsDrawerActions.close())
    	},
        onContentRendered: (container) => {
            dispatch(CommentsDrawerActions.renderedContent(container));
        }
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(CommentsDrawer );
